import { Component, Input, OnInit } from '@angular/core';
import { LinkPreviewService } from '@app/core/services/link-preview.service';
import { Link } from 'ngx-linkifyjs';

@Component({
  selector: 'app-link-preview-container',
  templateUrl: './link-preview-container.component.html',
  styleUrls: ['./link-preview-container.component.scss']
})
export class LinkPreviewContainerComponent implements OnInit {
  @Input() links: Link[] = [];
  @Input() hasLink: boolean;
  @Input() linkPreview = [];
  @Input() postId: any;

  foundLinks = [];
  isLoaded = true;

  constructor(private linkPreviewService: LinkPreviewService) { }

  ngOnInit() {
    if (this.hasLink) {
      this.links.forEach((element: Link) => {
        if (element.type !== "hashtag" && element.type !== "email") {
          this.fetchLink(element.value);
        }
      });
    } else {
      this.isLoaded = true;
      this.foundLinks = this.linkPreview;
    }
  }

  fetchLink(url) {
    this.isLoaded = false;
    this.linkPreviewService.fetchLink(url, this.postId).subscribe(
      (result) => {
        this.foundLinks.push(result);
        this.isLoaded = true;
      }, (errors) => {
        this.isLoaded = true;
      }
    );
  }
}
